<template>
  <div>
    <base-info ref="baseInfo" v-model="form" v-loading="loading" :base-data="baseData" :email="email" :contract-num="contractNum" />
    <div v-loading="loading" class="rj-page-card">
      <div class="rj-page-card__title">
        合同附件信息
      </div>
      <div class="rj-page-card__content">
        <contract-file v-if="form.id" :contract-num="form.id" />
      </div>
    </div>
    <rejected-list ref="rejectedList" v-loading="rejectedLoading" />
    <product-list ref="product" v-loading="productLoading" :is-test-project="form.isTestProject" :communication-order-discount="form.communicationOrderDiscount" :rebate-amount="form.rebateAmount" :sales-type="form.salesType" :rebate="form.rebate" :contract-id="form.id" :contract-type="form.contractType" :form="form" @chooseAddress="(val)=>{form.receiptAddressId=val.id}">
      <freight-info slot="freightInfo" ref="freightInfo" :form="form" />
    </product-list>
    <abatement-reminder v-model="form" :distributor-participate="form.distributorParticipate" :integrator-participate="form.integratorParticipate" />
    <dismissed-suggestion v-if="form.id" ref="rejected" :contract-id="form.id" />
    <actions :id="form.id" ref="actions" :is-hard-ware="ishard" :contract-type="form.contractType" />
  </div>
</template>
<script type="es6">
import baseInfo from './baseInfo';
import freightInfo from './freightInfo';
import actions from './actions';
import dismissedSuggestion from './dismissedSuggestion';
import actionMixin from './actionMixin';
import productList from './productList';
import rejectedList from './rejectedList';
import contractFile from '../../../Chief/contract/common/contractFile';
import abatementReminder from '../../../contractCommonInput/abatementReminder';
import axios, { getContractDetailAllInfoByConNum, getContractProductInfoByContractId, getReceiptAddressByContractId, splitHardware, getRejectedList, getRebateSummaryAgentInfo, paymentRatioCheck } from '@/API';
export default {
  mixins: [actionMixin],
  data () {
    return {
      form: {
        paymentMethodName: '立即',
        currencyId: 'CNY',
        distributorParticipate: '',
        integratorParticipate: '',
        extContractData: {}
      },
      loading: false,
      productLoading: false,
      ishard: true,
      rejectedLoading: false,
      contractId: '',
      email: '',
      baseData: {
        advanceCharge: '',
        prepaymentRatioNum: ''
      }
    };
  },
  props: {
    contractNum: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    baseInfo,
    productList,
    contractFile,
    actions,
    abatementReminder,
    dismissedSuggestion,
    rejectedList,
    freightInfo
  },
  computed: {},
  methods: {
    GetPaymentRatioCheck () {
      let contractId = {
        contractId: this.form.id
      };
      paymentRatioCheck(contractId).then((res) => {
        this.loading = false;
        let json = res.data;
        if (json.status === '200') {
          this.baseData.advanceCharge = json.data.advanceCharge;
          this.baseData.prepaymentRatioNum = json.data.prepaymentRatioNum;
        }
      }).catch((res) => {
      });
    },
    initData () {
      this.loading = true;
      axios.all([
        getContractDetailAllInfoByConNum(this.contractNum),
        getRebateSummaryAgentInfo({ contractNum: this.contractNum })
      ]).then((res) => {
        this.loading = false;
        let json1 = res[0].data;
        let json2 = res[1].data;
        if (json1.status === '200') {
          this.form = json1.data;
          // 赋值邮箱字段
          this.email = json1.data.setNoticeMail;
          this.form.distributorParticipate = json1.data.distributorParticipate; // 是否有分销商参与 boolean
          this.form.integratorParticipate = json1.data.integratorParticipate; // 是否有首级参与 boolean
          this.form.paymentMethodName = '立即';
          this.form.currencyId = 'CNY';
          this.form.orderUnit = json1.data.orderUnit;
          this.form.isEmbeddedSoftware = json1.data.isEmbeddedSoftware;
          this.form.extContractData = json1.data.extContractData;
          this.$nextTick(() => {
            this.$refs.baseInfo.setInitData();
            this.initProduct();
            this.GetPaymentRatioCheck();
            this.initRejected(json1.data.id);
            this.isShowHardWare();
          });
        }
        if (json2.status === '200') {
          this.$set(this.form, 'allowUsedFL', json2.data.availableAmount);
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    initProduct () {
      this.productLoading = true;
      axios.all([
        getContractProductInfoByContractId(this.form.id),
        getReceiptAddressByContractId(this.form.id)
      ]).then((res) => {
        let fjson = res[0].data;
        this.form.authorizationEmail = res[0].data.data[0].authorizationEmail ? res[0].data.data[0].authorizationEmail : '';
        let sjson = res[1].data;
        this.productLoading = false;

        // if (this.form.contractProductInfos && this.form.contractProductInfos.length > 0) {
        //  this.form.receiptAddressId = this.form.contractProductInfos[0].addressId;
        // }

        if (fjson.status === '200') {
          this.$refs.product.productList = fjson.data;
          // 让表格重新计算高度，防止合计被fixed属性破坏宽度
          this.$nextTick(() => {
            if (fjson.data.length > 10) {
              this.$refs.product.tableHeight = 500;
            } else {
              this.$refs.product.tableHeight = '';
            }
          });
        }
        if (sjson.status === '200') {
          this.$refs.product.address = sjson.data;
        }
      }).catch(() => {
        this.productLoading = false;
      });
    },
    toHardWare () {
      splitHardware(this.form.id).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$notify.success(json.err);
          this.initProduct();
        }
      }).catch((e) => {
        this.$notify.success('拆分失败');
      });
    },
    isShowHardWare () {
      if (this.form.contractType === 'SMB分销下单' || this.form.contractType === '服务商分销下单' || this.form.contractType === '服务下单' || this.form.contractType === '国际业务下单') {
        this.ishard = false;
      } else if (this.form.isEmbeddedSoftware) {
        this.ishard = false;
      } else {
        this.ishard = true;
      }
    },
    initRejected (contractId) {
      this.rejectedLoading = true;
      getRejectedList(contractId).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$refs.rejectedList.rejectedList = json.data;
          this.rejectedLoading = false;
        }
      }).catch((res) => {
        this.rejectedLoading = false;
      });
    }
  },
  mounted () {
    this.initData();
  },
  watch: {
    contractNum (val) {
      console.log(val, 'contractNum');
    }
  }
};
</script>
<style>
  .rj-page-card:nth-of-type(3){
    margin-bottom: 0;
    padding-bottom: 0;
    overflow: hidden;
  }
</style>
